import * as React from 'react';
import { ModalProps } from 'antd/lib/modal/Modal';
import { Modal } from 'antd';
import classNames from 'classnames';

const FullScreenModal: React.FC<React.PropsWithChildren<ModalProps>> = ({ children, ...props }) => {
  return (
    <Modal
      {...props}
      className={classNames(props.className, 'ant-modal-full-screen')}
      destroyOnClose
      maskClosable={false}
      footer={null}
      transitionName=""
      maskTransitionName=""
      centered
      // 100vw does not work well when "System Preferences > General > Show scroll bars" is set to "Always"
      // https://destroytoday.com/blog/100vw-and-the-horizontal-overflow-you-probably-didnt-know-about
      width="100%"
      bodyStyle={{
        height: '100vh',
      }}
    >
      {children}
    </Modal>
  );
};

export default FullScreenModal;
